import React from "react";

export const ErrorPage = ({ className = "" }) => {

    const handleReload = () => window.location.reload();
    const handleGoToHomePage = () => window.location.replace(window.location.origin);

    return (
        <div className={`error-container ${className}`}>
            <h1>Oops! Something Went Wrong</h1>
            <p>We're sorry for the inconvenience. Please try reloading the page, or returning to the Home page. Our engineering team is currently working to resolve the issue.</p>
            <div className="buttons">
                <button onClick={handleReload}>Reload</button>
                <button onClick={handleGoToHomePage}>Home Page</button>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/shared/components/errors/ErrorPage.js